import { toast } from "sonner";

// intercept global fetch to show ratelimit toast
if (typeof window !== "undefined") {
  const w = window as Window & { __fetch429Patched?: boolean };
  if (!w.__fetch429Patched) {
    w.__fetch429Patched = true;
    const originalFetch: typeof fetch = globalThis.fetch.bind(globalThis);
    let lastToastAt = 0;
    globalThis.fetch = (async (
      input: RequestInfo | URL,
      init?: RequestInit
    ) => {
      const res = await originalFetch(input as any, init as any);
      if (res && res.status === 429) {
        const now = Date.now();
        if (now - lastToastAt > 2000) {
          toast.error("you are being ratelimited");
          lastToastAt = now;
        }
      }
      return res;
    }) as typeof fetch;
  }
}
